import React from 'react';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { ExternalLink, Check } from 'lucide-react';

const BookCard = ({ book, onShare }) => {
  return (
    <Card className="group overflow-hidden transition-all duration-300 hover:shadow-2xl hover:-translate-y-2 bg-white border-2 border-gray-100">
      <div className="relative overflow-hidden bg-gradient-to-br from-orange-50 to-white p-6">
        <img
          src={book.coverImage}
          alt={book.title}
          className="w-full h-80 object-contain mx-auto transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute top-4 right-4 bg-orange-500 text-white px-4 py-2 rounded-full font-bold text-lg shadow-lg">
          {book.price}
        </div>
      </div>
      
      <CardHeader className="space-y-3">
        <CardTitle className="text-2xl font-bold text-gray-900 line-clamp-2 leading-tight">
          {book.title}
        </CardTitle>
        <CardDescription className="text-gray-600 line-clamp-2">
          {book.subtitle}
        </CardDescription>
        <p className="text-sm text-orange-600 font-semibold">
          by {book.author}
        </p>
      </CardHeader>

      <CardContent className="space-y-4">
        <p className="text-gray-700 leading-relaxed">
          {book.description}
        </p>
        
        <div className="space-y-2">
          <p className="font-semibold text-gray-900 text-sm uppercase tracking-wide">
            Key Features:
          </p>
          <ul className="space-y-2">
            {book.features.map((feature) => (
              <li key={feature} className="flex items-start gap-2 text-sm text-gray-700">
                <Check className="h-5 w-5 text-orange-500 flex-shrink-0 mt-0.5" />
                <span>{feature}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="flex gap-4 text-sm text-gray-600 pt-2 border-t border-gray-100">
          <span className="font-medium">{book.pages} pages</span>
          <span className="text-gray-400">•</span>
          <span>ISBN: {book.isbn}</span>
        </div>
      </CardContent>

      <CardFooter className="flex flex-col gap-3 bg-gray-50 pt-6">
        <a
          href={book.amazonLink}
          target="_blank"
          rel="noopener noreferrer"
          className="w-full"
        >
          <Button
            className="w-full bg-orange-500 hover:bg-orange-600 text-white font-bold py-6 text-lg transition-all duration-300 hover:shadow-lg"
            size="lg"
          >
            <ExternalLink className="mr-2 h-5 w-5" />
            Buy on Amazon
          </Button>
        </a>
        
        <Button
          variant="outline"
          className="w-full border-2 border-orange-500 text-orange-600 hover:bg-orange-50 font-semibold py-6 transition-all duration-300"
          size="lg"
          onClick={() => onShare(book)}
        >
          Share This Book
        </Button>
      </CardFooter>
    </Card>
  );
};

export default BookCard;
